// extracted by mini-css-extract-plugin
module.exports = {"content":"Reference_content__1DBSW","submitBtn":"Reference_submitBtn___Vubw"};